var theme = theme || {}

/**
 * Met à jour l'affichage des vignettes produit en fonction de la variante sélectionnée.
 * Les thumbnails sont filtrés selon le nom de l'option choisie (#couleur, #all...).
 */
function updateVariantThumbnails(productId) {
  window.addEventListener(`theme:product:${productId}:variantChanged`, ({ detail: { variant }}) => {
    if (variant.options.length > 0) {
      let thumbnailAlt = "#" + variant.options[0].split(" ").join("-").toLowerCase();
      document.querySelectorAll('.product-media--thumb')?.forEach(media => {
        if (media.attributes['thumbnail-alt'].value.toLowerCase().includes(thumbnailAlt) || media.attributes['thumbnail-alt'].value.includes("#all")) {
          media.classList.remove("hide")
        } else { 
          media.classList.add("hide")
        }
      });
    }
  });
}

/**
 * Recharge le panier (cart drawer) depuis Shopify
 * et met à jour les totaux avec les méthodes du thème.
 */
async function waitForUpdateAllHtml(retries = 10, delay = 200) {
  for (let i = 0; i < retries; i++) {
    if (window.theme && theme.cart && typeof theme.cart.updateAllHtml === 'function') {
      return true;
    }
    await new Promise(res => setTimeout(res, delay));
  }
  return false;
}

async function updateCart(){
  let response = await fetch('/cart?sections=cart-drawer');
  let cartJSON = await response.json();

  const available = await waitForUpdateAllHtml();
  if (available) {
    theme.cart.updateAllHtml(cartJSON);
    if (typeof theme.cart.fetchTotals === 'function') theme.cart.fetchTotals();
  } else {
    console.warn('theme.cart.updateAllHtml non disponible après attente');
  }
}

/**
 * Ajoute un échantillon (wrap) au panier avec la variante définie.
 */
async function addWrapToCart(){
  const wrapId = 15608405557597;
  const wrapVariantId = 58474959896925;
  let addToCart = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      'items': [{
        'id': wrapVariantId,
        'form_type': 'product',
        'utf8': '✓',
        'product-id': wrapId,
        'quantity': 1,
        'section-id': 'product--quick-add--form'
      }]
    })
  });
  await updateCart()
}

/**
 * Remplace tous les liens vers la fiche produit de l’échantillon
 * pour les transformer en bouton "ajouter au panier".
 */
function replaceSampleLinks() {
  document.querySelectorAll('a[href="/products/echantillon-creme?variant=58474959896925"]').forEach(link => {
    link.setAttribute('href', '#');
    link.addEventListener('click', (event) => {
      event.preventDefault();
      addWrapToCart();
    });
  });
}
document.addEventListener('DOMContentLoaded', replaceSampleLinks);
window.addEventListener('theme:cart:updated', replaceSampleLinks);


/* ------------------------------
   Gestion de la limite d’échantillons
--------------------------------*/

const SAMPLE_VARIANT_ID = 58474959896925;
const MAX_SAMPLES = 2;

/**
 * Récupère l'état actuel du panier (cart.js).
 */
async function getCartJson() {
  const res = await fetch('/cart.js', { credentials: 'same-origin' });
  return await res.json();
}

/**
 * Modifie la quantité d'une ligne du panier via son lineKey.
 */
async function changeLineQuantityByKey(lineKey, quantity) {
  const res = await fetch('/cart/change.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: lineKey, quantity: quantity })
  });
  if (!res.ok) throw new Error('Erreur lors de la modification du panier');
  return await res.json();
}

/**
 * Retourne la quantité totale d’échantillons dans le panier.
 */
function sumSampleQuantity(cart) {
  return cart.items
    .filter(i => Number(i.variant_id) === Number(SAMPLE_VARIANT_ID))
    .reduce((s, i) => s + (i.quantity || 0), 0);
}

/**
 * Vérifie si la limite d’échantillons est dépassée.
 * Si oui, supprime l’excédent et affiche un message d’information.
 */
async function enforceSampleLimit(cart) {
  const sampleItems = cart.items.filter(i => Number(i.variant_id) === Number(SAMPLE_VARIANT_ID));
  let total = sampleItems.reduce((s, i) => s + i.quantity, 0);
  if (total <= MAX_SAMPLES) return false; 

  let excess = total - MAX_SAMPLES;

  for (let idx = sampleItems.length - 1; idx >= 0 && excess > 0; idx--) {
    const item = sampleItems[idx];
    const reducible = Math.min(item.quantity, excess);
    const newQty = item.quantity - reducible; 
    await changeLineQuantityByKey(item.key, newQty);
    excess -= reducible;
  }

  if (typeof updateCart === 'function') {
    await updateCart();
  } else {
    try {
      const cartJSON = await fetch('/cart?sections=cart-drawer', { credentials: 'same-origin' }).then(r => r.json());
      if (window.theme && theme.cart && typeof theme.cart.updateAllHtml === 'function') {
        theme.cart.updateAllHtml(cartJSON);
        if (typeof theme.cart.fetchTotals === 'function') theme.cart.fetchTotals();
      }
    } catch (e) {}
  }

  showCartMessage('Vous ne pouvez ajouter que 2 échantillons maximum par commande.');
  return true;
}

/**
 * Ajoute un échantillon au panier en respectant la limite définie.
 */
async function addWrapToCart() {
  const wrapVariantId = SAMPLE_VARIANT_ID;

  const cart = await getCartJson();
  const total = sumSampleQuantity(cart);
  const allowed = MAX_SAMPLES - total;
  if (allowed <= 0) {
    showCartMessage('Vous ne pouvez ajouter que 2 échantillons maximum par commande.');
    return;
  }

  const qtyToAdd = Math.min(1, allowed);

  await fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: wrapVariantId, quantity: qtyToAdd }] })
  });

  if (typeof updateCart === 'function') await updateCart();
}

/**
 * Affiche un message d’alerte dans le panier, sous la barre de livraison.
 * Le message disparaît automatiquement après 5 secondes.
 */
function showCartMessage(message) {
  const existing = document.getElementById('cart-message');
  if (existing) {
    clearTimeout(existing._timeoutId);
    existing.remove();
  }

  const shippingBar = document.querySelector('.cart--shipping-bar');
  if (!shippingBar) return;

  const container = document.createElement('div');
  container.id = 'cart-message';
  container.style.background = '#fff3cd';
  container.style.color = '#856404';
  container.style.border = '1px solid #ffeeba';
  container.style.padding = '10px';
  container.style.margin = '10px 0';
  container.style.borderRadius = '4px';
  container.style.fontSize = '14px';
  container.style.textAlign = 'center';
  container.textContent = message;

  if (shippingBar.parentNode) {
    shippingBar.parentNode.insertBefore(container, shippingBar.nextSibling);
  }

  container._timeoutId = setTimeout(() => {
    container.remove();
  }, 5000);
}


/* Écouteurs d’événements pour surveiller le panier */
window.addEventListener('theme:cart:productAdded', async ({ detail: variantId }) => {
  try {
    if (Number(variantId) !== Number(SAMPLE_VARIANT_ID)) return;
    const cart = await getCartJson();
    await enforceSampleLimit(cart);
  } catch (e) {
    console.error('enforceSampleLimit error (productAdded):', e);
  }
});

window.addEventListener('theme:cart:updated', async () => {
  try {
    const cart = await getCartJson();
    await enforceSampleLimit(cart);
  } catch (e) {
    console.error('enforceSampleLimit error (cart:updated):', e);
  }
});


/* ------------------------------
   Gestion de l’affichage des swatches
--------------------------------*/

/**
 * Limite le nombre de swatches visibles à 4 sur les product-cards.
 * Si plus de 4 swatches existent, affiche un bouton "restants".
 */
function updateVariantCount() {
  const swatchesContainers = document.querySelectorAll('.swatches--container');

  swatchesContainers.forEach((container) => {
    const parent = container.closest('.product-card--swatches--column-view');
    if (parent) {
      const swatches = container.querySelectorAll('.swatch');
      const limit = 4;

      swatches.forEach((swatch, index) => {
        if (index >= limit) {
          swatch.style.display = 'none';
        }
      });

      const remainingSwatches = container.querySelector('.swatches--remaining');
      if (swatches.length > limit && remainingSwatches) {
        remainingSwatches.classList.remove('hide');
      }
    }
  });
}

/* Cache le formulaire de contact du footer sur la page de l'espace pro */

if (window.location.pathname === '/collections/espace-pro') {
  const contactSection = document.querySelector('#shopify-section-sections--24575620284765__contact_76inVB');
  if (contactSection) {
    contactSection.style.display = 'none';
  }
}



document.addEventListener('DOMContentLoaded', updateVariantCount);
window.addEventListener('theme:search:reloaded', updateVariantCount);


